import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Provider } from "urql";
import { Flex } from "@base-ui";
import { useWindowWidth } from "hooks";
import { initiateUrqlClient } from "hooks/initiateUrqlClient";
import { cmsApiServiceUrl } from "@microServices";
import NotificationBanner from "@notifications/NotificationBanner";
import useHeader from "./header.hook";
import HeaderDesktop from "./desktop/Header";
import HeaderMobile from "./mobile/Header";

/*
There's too many header-entries for it to be possible to use the 'desktop' header on a smaller than 1300px screen.
Once could differentiate between logged in/out since that's one more entry, but for now we just use the same.
*/
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var headerBreakpoint = 1300;
var Header = function Header() {
  var windowWidth = useWindowWidth();
  var headerProps = useHeader();

  //desktop-header
  if (windowWidth >= headerBreakpoint) {
    return /*#__PURE__*/_jsx(HeaderDesktop, _objectSpread({}, headerProps));
  }
  return /*#__PURE__*/_jsx(HeaderMobile, _objectSpread({}, headerProps));
};
export default function HeaderWrapper() {
  return /*#__PURE__*/_jsx(Provider, {
    value: initiateUrqlClient(cmsApiServiceUrl),
    children: /*#__PURE__*/_jsxs(Flex.Column, {
      children: [/*#__PURE__*/_jsx(Header, {}), /*#__PURE__*/_jsx(NotificationBanner, {})]
    })
  });
}